export const SAMPLE_STATUSES = ["Requested", "In Production", "Shipped", "Feedback Received", "Approved", "Rejected"];export const ARTWORK_STATUSES = ["Draft", "Sent to Customer", "Approved", "Revision Requested", "Rejected"];
export const PRICE_INDEXES = ["EUWID Papierpreisindex", "Plastixx PP Index", "LME Aluminium", "None"];

export const FIELDS = {
  accounts: [
    { key: "name", label: "name", type: "text", required: true },
    { key: "type", label: "type", type: "select", options: "account_types" },
    { key: "primary_segment", label: "primary_segment", type: "select", options: "segments", required: true },
    { key: "segments", label: "segments", type: "multiselect", options: "segments" },
    { key: "abc_class", label: "abc_class", type: "select", options: "abc_classes" },
    { key: "status", label: "status", type: "select", options: "account_statuses" },
    { key: "annual_spend", label: "annual_spend", type: "number" },
    { key: "payment_terms", label: "payment_terms", type: "select", options: "payment_terms" },
    { key: "incoterm", label: "incoterm", type: "select", options: "incoterms" },
    { key: "credit_limit", label: "credit_limit", type: "number" },
    { key: "vat_id", label: "vat_id", type: "text" },
    { key: "city", label: "city", type: "text" },
    { key: "billing_address", label: "billing_address", type: "text" },
    { key: "region", label: "region", type: "select", options: "territories" },
    { key: "customer_since", label: "customer_since", type: "date" },
    { key: "certifications", label: "certifications", type: "multiselect", options: "certifications" },
    { key: "parent_account_id", label: "parent_account", type: "account_ref" },
    { key: "owning_plant_ids", label: "owning_plants", type: "plant_multi" },
    { key: "primary_plant_id", label: "primary_plant", type: "plant_ref" },
    { key: "account_team", label: "account_team", type: "user_multi" },
  ],
  contacts: [
    { key: "first_name", label: "name", type: "text", required: true },
    { key: "last_name", label: "name", type: "text", required: true },
    { key: "title", label: "title_field", type: "text" },
    { key: "department", label: "department", type: "select", options: "departments" },
    { key: "email", label: "email", type: "text" },
    { key: "phone", label: "phone", type: "text" },
    { key: "mobile", label: "mobile", type: "text" },
    { key: "linkedin", label: "linkedin", type: "text" },
    { key: "preferred_language", label: "preferred_language", type: "select", optionsList: ["DE", "EN", "FR", "ES", "IT"] },
    { key: "buying_role", label: "buying_role", type: "select", options: "buying_roles" },
    { key: "birthday", label: "birthday", type: "date" },
    { key: "account_ids", label: "accounts", type: "account_multi" },
    { key: "notes", label: "notes", type: "textarea" },
  ],
  leads: [
    { key: "company", label: "company", type: "text", required: true },
    { key: "contact_name", label: "contact", type: "text" },
    { key: "email", label: "email", type: "text" },
    { key: "phone", label: "phone", type: "text" },
    { key: "source", label: "source", type: "select", options: "lead_sources" },
    { key: "trade_fair", label: "trade_fair", type: "text" },
    { key: "status", label: "status", type: "select", options: "lead_statuses" },
    { key: "segment", label: "segment", type: "select", options: "segments" },
    { key: "estimated_volume", label: "estimated_volume", type: "number" },
    { key: "product_interest", label: "product_interest", type: "select", options: "product_types" },
    { key: "region", label: "region", type: "select", optionsList: ["DACH", "Southern Europe", "LATAM", "Asia", "Benelux", "Nordics"] },
    { key: "engagement", label: "engagement", type: "number" },
  ],
  opportunities: [
    { key: "name", label: "name", type: "text", required: true },
    { key: "account_id", label: "account", type: "account_ref", required: true },
    { key: "location_id", label: "location", type: "location_ref" },
    { key: "amount", label: "amount", type: "number", required: true },
    { key: "currency", label: "currency", type: "select", optionsList: ["EUR", "USD", "GBP", "CHF"] },
    { key: "probability", label: "probability", type: "number" },
    { key: "close_date", label: "close_date", type: "date" },
    { key: "stage", label: "stage", type: "select", options: "opp_stages", required: true },
    { key: "product_type", label: "product_type", type: "select", options: "product_types" },
    { key: "print_technology", label: "print_technology", type: "select", options: "print_technologies" },
    { key: "substrate", label: "substrate", type: "select", options: "substrates" },
    { key: "finishing", label: "finishing", type: "multiselect", options: "finishings" },
    { key: "annual_volume", label: "annual_volume", type: "number" },
    { key: "volume_unit", label: "annual_volume", type: "select", optionsList: ["1000 pcs", "sqm", "linear m"] },
    { key: "num_skus", label: "num_skus", type: "number" },
    { key: "num_colors", label: "num_colors", type: "number" },
    { key: "business_type", label: "business_type", type: "select", options: "business_types" },
    { key: "competitors", label: "competitors", type: "multiselect", options: "competitors" },
    { key: "close_reason", label: "close_reason", type: "select", options: "close_reasons" },
  ],
  complaints: [
    { key: "account_id", label: "account", type: "account_ref", required: true },
    { key: "location_id", label: "location", type: "location_ref" },
    { key: "contact_name", label: "contact", type: "text" },
    { key: "order_number", label: "order_number", type: "text" },
    { key: "article_number", label: "article_number", type: "text" },
    { key: "date_received", label: "date_received", type: "date" },
    { key: "received_via", label: "received_via", type: "select", options: "received_via" },
    { key: "defect_category", label: "defect_category", type: "select", options: "defect_categories", required: true },
    { key: "severity", label: "severity", type: "select", options: "severities", required: true },
    { key: "claimed_quantity", label: "claimed_qty", type: "number" },
    { key: "claimed_value", label: "claimed_value", type: "number" },
  ],
  quotes: [
    { key: "account_id", label: "account", type: "account_ref", required: true },
    { key: "location_id", label: "location", type: "location_ref" },
    { key: "opportunity_id", label: "opportunities", type: "opp_ref" },
    { key: "validity_date", label: "validity", type: "date" },
    { key: "incoterm", label: "incoterm", type: "select", options: "incoterms" },
    { key: "payment_terms", label: "payment_terms", type: "select", options: "payment_terms" },
    { key: "currency", label: "currency", type: "select", optionsList: ["EUR", "USD", "GBP", "CHF"] },
  ],
  samples: [
    { key: "account_id", label: "account", type: "account_ref", required: true },
    { key: "opportunity_id", label: "opportunities", type: "opp_ref" },
    { key: "product_type", label: "product_type", type: "select", options: "product_types" },
    { key: "substrate", label: "substrate", type: "select", options: "substrates" },
    { key: "quantity", label: "quantity", type: "number" },
    { key: "requested_date", label: "requested_date", type: "date" },
    { key: "due_date", label: "due_date", type: "date" },
    { key: "status", label: "status", type: "select", optionsList: SAMPLE_STATUSES },
    { key: "tracking_number", label: "tracking_number", type: "text" },
    { key: "notes", label: "notes", type: "textarea" },
  ],
  artworks: [
    { key: "name", label: "name", type: "text", required: true },
    { key: "account_id", label: "account", type: "account_ref", required: true },
    { key: "opportunity_id", label: "opportunities", type: "opp_ref" },
    { key: "version", label: "version", type: "number" },
    { key: "notes", label: "notes", type: "textarea" },
  ],
  contracts: [
    { key: "name", label: "name", type: "text", required: true },
    { key: "account_id", label: "account", type: "account_ref", required: true },
    { key: "start_date", label: "start_date", type: "date" },
    { key: "end_date", label: "end_date", type: "date", required: true },
    { key: "annual_value", label: "annual_value", type: "number" },
    { key: "price_index", label: "price_index", type: "select", optionsList: PRICE_INDEXES },
    { key: "index_base_value", label: "index_base_value", type: "number" },
    { key: "indexation_threshold_pct", label: "indexation_threshold", type: "number" },
    { key: "payment_terms", label: "payment_terms", type: "select", options: "payment_terms" },
    { key: "status", label: "status", type: "select", optionsList: ["Active", "Renewed", "Terminated"] },
    { key: "indexation_clause", label: "indexation_clause", type: "textarea" },
  ],
  locations: [
    { key: "name", label: "name", type: "text", required: true },
    { key: "account_id", label: "account", type: "account_ref", required: true },
    { key: "site_type", label: "site_type", type: "select", optionsList: ["Plant", "DC/Warehouse", "HQ/Office", "Co-Packer Site"] },
    { key: "address", label: "billing_address", type: "text" },
    { key: "city", label: "city", type: "text" },
    { key: "country", label: "country", type: "text" },
    { key: "region", label: "region", type: "select", options: "territories" },
    { key: "lat", label: "lat", type: "number" },
    { key: "lng", label: "lng", type: "number" },
    { key: "timezone", label: "timezone", type: "select", options: "timezones" },
    { key: "currency", label: "currency", type: "select", optionsList: ["EUR", "USD", "GBP", "CHF", "BRL", "PLN", "TRY", "MXN", "SGD", "DKK"] },
    { key: "erp_customer_number", label: "erp_number", type: "text" },
  ],
};

export const STAGES = ["Qualification", "Sampling/Trial", "Quotation", "Negotiation", "Verbal Award", "Contract", "Closed Won", "Closed Lost"];
export const OPEN_STAGES = STAGES.slice(0, 6);

export const STAGE_COLORS = {
  Qualification: "bg-slate-100 text-slate-700", "Sampling/Trial": "bg-blue-50 text-blue-700",
  Quotation: "bg-indigo-50 text-indigo-700", Negotiation: "bg-amber-50 text-amber-700",
  "Verbal Award": "bg-orange-50 text-orange-700", Contract: "bg-emerald-50 text-emerald-700",
  "Closed Won": "bg-emerald-100 text-emerald-800", "Closed Lost": "bg-red-50 text-red-600",
};

export const SEVERITY_COLORS = { Critical: "bg-red-100 text-red-700", Major: "bg-amber-100 text-amber-700", Minor: "bg-slate-100 text-slate-600" };

export const COMPLAINT_STATUSES = ["New", "Acknowledged", "Under Investigation", "Root Cause Identified",
  "Corrective Action", "8D Report Sent", "Closed (Accepted)", "Closed (Rejected)"];

export const QUOTE_STATUS_COLORS = {
  Draft: "bg-slate-100 text-slate-600", Sent: "bg-blue-50 text-blue-700",
  "Under Negotiation": "bg-amber-50 text-amber-700", Accepted: "bg-emerald-100 text-emerald-800",
  Rejected: "bg-red-50 text-red-600", Expired: "bg-slate-200 text-slate-500", Superseded: "bg-slate-200 text-slate-500",
};

export const SAMPLE_STATUS_COLORS = {
  Requested: "bg-slate-100 text-slate-600", "In Production": "bg-blue-50 text-blue-700",
  Shipped: "bg-indigo-50 text-indigo-700", "Feedback Received": "bg-amber-50 text-amber-700",
  Approved: "bg-emerald-100 text-emerald-800", Rejected: "bg-red-50 text-red-600",
};

export const ARTWORK_STATUS_COLORS = {
  Draft: "bg-slate-100 text-slate-600", "Sent to Customer": "bg-blue-50 text-blue-700",
  Approved: "bg-emerald-100 text-emerald-800", "Revision Requested": "bg-amber-50 text-amber-700",
  Rejected: "bg-red-50 text-red-600",
};

export const CONTRACT_STATUS_COLORS = {
  Active: "bg-emerald-50 text-emerald-700", "Expiring Soon": "bg-amber-100 text-amber-700",
  Expired: "bg-red-100 text-red-700", Renewed: "bg-blue-50 text-blue-700", Terminated: "bg-slate-200 text-slate-500",
};

export const IB_BUG_STATUSES = ["New", "Confirmed", "In Progress", "Fixed", "Verified", "Closed"];
export const IB_BUG_TERMINAL = ["Won't Fix", "Duplicate", "Can't Reproduce"];
export const IB_IDEA_STATUSES = ["New", "Under Review", "Planned", "In Progress", "Released"];
export const IB_IDEA_TERMINAL = ["Declined"];
export const IB_SEVERITIES = ["Critical", "Major", "Minor", "Cosmetic"];
export const IB_PRIORITIES = ["Now", "Next", "Later", "Icebox"];

export const IB_STATUS_COLORS = {
  New: "bg-slate-100 text-slate-600", Confirmed: "bg-blue-50 text-blue-700",
  "Under Review": "bg-blue-50 text-blue-700", Planned: "bg-indigo-50 text-indigo-700",
  "In Progress": "bg-amber-50 text-amber-700", Fixed: "bg-teal-50 text-teal-700",
  Verified: "bg-emerald-50 text-emerald-700", Closed: "bg-emerald-100 text-emerald-800",
  Released: "bg-emerald-100 text-emerald-800",
  "Won't Fix": "bg-slate-200 text-slate-500", Duplicate: "bg-slate-200 text-slate-500",
  "Can't Reproduce": "bg-red-50 text-red-600", Declined: "bg-red-50 text-red-600",
};

export const IB_SEVERITY_COLORS = {
  Critical: "bg-red-100 text-red-700", Major: "bg-amber-100 text-amber-700",
  Minor: "bg-slate-100 text-slate-600", Cosmetic: "bg-slate-50 text-slate-500",
};

export const IB_PRIORITY_COLORS = {
  Now: "bg-red-100 text-red-700", Next: "bg-amber-100 text-amber-700",
  Later: "bg-blue-50 text-blue-700", Icebox: "bg-slate-100 text-slate-500",
};

export const IB_MODULE_AREAS = [
  "Dashboard", "Accounts", "Locations", "Contacts", "Leads", "Opportunities", "Quotes",
  "Complaints", "Samples & Artwork", "Contracts", "Activities", "Reports",
  "Forecast & Targets", "Customer Forecast", "Trade Fair Mode", "Plant View",
  "Contract Deadlines", "Forecast Approvals", "Admin", "Other",
];

// ---- Multi-line-item structure (Opportunities & Quotes) ----
export const LINE_TYPES = [
  "Product", "Artwork/Prepress Setup", "Tooling/Die Setup",
  "Storage/Warehousing (VMI)", "Freight/Logistics", "Sample/Trial Run", "Other",
];
export const LINE_TYPE_LABELS = {
  "Product": "lt_product", "Artwork/Prepress Setup": "lt_artwork", "Tooling/Die Setup": "lt_tooling",
  "Storage/Warehousing (VMI)": "lt_storage", "Freight/Logistics": "lt_freight",
  "Sample/Trial Run": "lt_sample", "Other": "lt_other",
};
export const PRODUCT_FAMILIES = [
  "Roll/Pressure-Sensitive Labels", "Folding Cartons", "Flexible Packaging (Pouches/Film)", "Other",
];
export const PRODUCT_FAMILY_LABELS = {
  "Roll/Pressure-Sensitive Labels": "pf_labels", "Folding Cartons": "pf_cartons",
  "Flexible Packaging (Pouches/Film)": "pf_flexible", "Other": "pf_other",
};
export const LINE_UNITS = ["1000 pcs", "pcs", "m²", "running m", "pallets", "rolls", "cases", "kg", "lot"];

// pricing mode: per_1000 | per_unit | flat
export const LINE_TYPE_PRICING = {
  "Product": "per_1000", "Artwork/Prepress Setup": "flat", "Tooling/Die Setup": "flat",
  "Storage/Warehousing (VMI)": "flat", "Freight/Logistics": "flat", "Sample/Trial Run": "flat", "Other": "flat",
};
export const FAMILY_PRICING = {
  "Roll/Pressure-Sensitive Labels": "per_1000", "Folding Cartons": "per_unit",
  "Flexible Packaging (Pouches/Film)": "per_unit", "Other": "per_unit",
};
export const FAMILY_DEFAULT_UNIT = {
  "Roll/Pressure-Sensitive Labels": "1000 pcs", "Folding Cartons": "pcs",
  "Flexible Packaging (Pouches/Film)": "pcs", "Other": "pcs",
};

// family-specific spec fields shown in the adaptive spec panel
export const FAMILY_SPECS = {
  "Roll/Pressure-Sensitive Labels": [
    { key: "material", label: "spec_facestock", type: "text" },
    { key: "adhesive", label: "spec_adhesive", type: "text" },
    { key: "liner", label: "spec_liner", type: "text" },
    { key: "print_process", label: "spec_print_process", type: "text" },
    { key: "colors", label: "num_colors", type: "number" },
    { key: "finish", label: "spec_finish", type: "text" },
    { key: "die_shape", label: "spec_die_shape", type: "text" },
    { key: "core_size", label: "core_size", type: "text" },
    { key: "labels_per_roll", label: "labels_per_roll", type: "number" },
    { key: "width", label: "width", type: "number" },
    { key: "height", label: "height", type: "number" },
  ],
  "Folding Cartons": [
    { key: "board_type", label: "spec_board_type", type: "text" },
    { key: "caliper", label: "spec_caliper", type: "text" },
    { key: "flute", label: "spec_flute", type: "text" },
    { key: "print_process", label: "spec_print_process", type: "text" },
    { key: "colors", label: "num_colors", type: "number" },
    { key: "coating", label: "spec_coating", type: "text" },
    { key: "die_cut", label: "spec_die_cut", type: "text" },
    { key: "folding_pattern", label: "spec_folding_pattern", type: "text" },
    { key: "units_per_case", label: "spec_units_per_case", type: "number" },
  ],
  "Flexible Packaging (Pouches/Film)": [
    { key: "film_structure", label: "spec_film_structure", type: "text" },
    { key: "pouch_format", label: "spec_pouch_format", type: "text" },
    { key: "print_process", label: "spec_print_process", type: "text" },
    { key: "colors", label: "num_colors", type: "number" },
    { key: "closure_type", label: "spec_closure", type: "text" },
    { key: "barrier", label: "spec_barrier", type: "text" },
  ],
  "Other": [
    { key: "spec_text", label: "spec_generic", type: "textarea" },
  ],
};

export function newLineItem(lineType = "Product") {
  const li = { line_type: lineType, description: "", quantity: 0, unit_price: 0, cost: 0,
    tooling_cost: 0, sourcing_type: "Internal", pricing_mode: LINE_TYPE_PRICING[lineType] || "flat" };
  if (lineType === "Product") {
    li.product_family = "Roll/Pressure-Sensitive Labels";
    li.pricing_mode = FAMILY_PRICING[li.product_family];
    li.unit = FAMILY_DEFAULT_UNIT[li.product_family];
    li.quantity = 50000; li.unit_price = 20; li.cost = 14; li.colors = 4;
    li.price_breaks = [];
  } else {
    li.unit = "lot"; li.quantity = 1;
  }
  return li;
}

// normalise legacy label-only lines into the new structure (choice 3a)
export function normalizeLine(l) {
  const n = { ...l };
  if (!n.line_type) n.line_type = "Product";
  if (n.line_type === "Product" && !n.product_family) n.product_family = "Roll/Pressure-Sensitive Labels";
  if (!n.pricing_mode) {
    n.pricing_mode = n.line_type === "Product"
      ? (FAMILY_PRICING[n.product_family] || "per_1000") : (LINE_TYPE_PRICING[n.line_type] || "flat");
  }
  if (!n.unit) {
    n.unit = n.line_type === "Product" ? (FAMILY_DEFAULT_UNIT[n.product_family] || "pcs") : "lot";
  }
  if (!n.sourcing_type) n.sourcing_type = "Internal";
  return n;
}

export function lineExtended(l) {
  const qty = Number(l.quantity) || 0;
  const unit = Number(l.unit_price) || 0;
  const tooling = Number(l.tooling_cost) || 0;
  const mode = l.pricing_mode || "per_1000";
  const base = mode === "per_unit" ? qty * unit : mode === "flat" ? unit : (qty / 1000) * unit;
  return base + tooling;
}

export function lineCost(l) {
  const qty = Number(l.quantity) || 0;
  const cost = Number(l.cost) || 0;
  const sub = Number(l.subcontractor_cost) || 0;
  const mode = l.pricing_mode || "per_1000";
  const base = mode === "per_unit" ? qty * cost : mode === "flat" ? cost : (qty / 1000) * cost;
  return base + sub;
}
